import PopupActions from '../../actions/PopupActions';
import UserStore from '../../stores/UserStore';
import PermissionStore from '../../stores/PermissionStore';
import { Permissions } from '../../constants/PermissionConstants';
import Popup from '../popup/Popup.react';

class ViewProfile extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var guest     = this.props.guest;
        var route     = this.props.route;
        var register  = UserStore.getState().register;
        var location = UserStore.getState().selectedLocation;
        return (
            <li>
                <div
                    className='btn-green'
                    onClick={() => { 
                        if(location.AuditCustomerInfoAccess && PermissionStore.userCan(Permissions.SuperUser)){
                            PopupActions.open('superuser-approval-audit', false, guest);
                        }else{
                            PopupActions.viewProfile(guest); 
                        }
                        
                    }} >

                    PROFILE
                </div>
            </li>
        );
    }
}

export default ViewProfile;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/ViewProfile.react.jsx